import { Observable } from 'rxjs/observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

@Injectable()
export class HeaderService {
    headerSettings : BehaviorSubject<any> = new BehaviorSubject({});
    dropdownList : BehaviorSubject<any> = new BehaviorSubject({});
    dropdownSettings : BehaviorSubject<any> = new BehaviorSubject([]);
    headerToolsList : BehaviorSubject<any> = new BehaviorSubject([]);

    constructor() {
        this.dropdownList.next([
            { item_class: 'language-box', item_text: 'Language Change' },
            { item_class: 'currency-box', item_text: 'Currency Change' },
            { item_class: 'contact-box', item_text: 'Contact Details' },
            { item_class: 'links-box', item_text: 'Additional Links' },
            { item_class: 'account-box', item_text: 'Account Settings' },
            { item_class: 'alert-box', item_text: 'Notifications / Alert' },
            { item_class: 'social-box', item_text: 'Social Icon' }
        ]);
        this.dropdownSettings.next({
            singleSelection: false,
            idField: 'item_class',
            textField: 'item_text',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 4,
            enableCheckAll: false,
            allowSearchFilter: false
        });
        this.headerToolsList.next([
            { item_class: 'notif', item_text: 'Notification' },
            { item_class: 'item-cart', item_text: 'Item Cart' },
            { item_class: 'search-modal', item_text: 'Search Modal' },
            { item_class: 'keyword-search', item_text: 'Keyword Search' },
        ]);
        if(localStorage.headerSettings){
            this.headerSettings.next(JSON.parse(localStorage.headerSettings));
        }else{
            let headerSettings = this.loadDefaults();
            this.headerSettings.next(headerSettings);
        }
    }

    setHeaderSettings(headerSettings){
        this.headerSettings.next(headerSettings);
    }

    loadDefaults() : any{
        let headerSettings = {
            TopBarStyle : '',
            dropdownList : this.dropdownList.getValue(),
            selectedItemsRight :  [
                { item_class: 'social-box', item_text: 'Social Icons' }
            ],
            selectedItemsLeft : [
                { item_class: 'contact-box', item_text: 'Contact Details' }
            ],
            dropdownSettings : this.dropdownSettings.getValue(),
            actionBarEnabled : false,
            headerToolsEnabled : false,
            topBarPosition : 'left',
            headerToolsList : this.headerToolsList.getValue(),
            selectedHeaderTools : [
                { item_class: 'keyword-search', item_text: 'Keyword Search' }
            ]
        }
        return headerSettings;
    }
}


// WEBPACK FOOTER //
// ./src/Services/HeaderService.ts